import { Currencies, Countries } from '@constants/enums';

export const COUNTRY_TO_CURRENCY_MAP: Record<Countries, Currencies> = {
  [Countries.USA]: Currencies.USD,
  [Countries.MX]: Currencies.MXN,
  [Countries.COL]: Currencies.COP,
};

export default COUNTRY_TO_CURRENCY_MAP;
